// extracted by mini-css-extract-plugin
export var split = "split-section--split--30mI-";
export var split__wrapper = "split-section--split__wrapper--1Baxh";
export var split__img = "split-section--split__img--p7f4M";
export var split__content = "split-section--split__content--388_u";